import React from "react";

import isIntuit from "Intuit/isIntuit";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import companyToken from "Utils/companyToken";
import { isNonPartner } from "Utils/isPartner";

import Footer from "Common/Footer";
import { getSiteLogo, getSitePartnerName } from "Common/Selectors";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";
import TopBarAccountLinks from "Common/TopBar/TopBarAccountLinks";

import { useGetCurrentCompanyApplicationQuery } from "./api";

// https://www.nngroup.com/articles/browser-and-gui-chrome/
export const Chrome = ({ children, branding, partnerLogo, partnerName }) => {
  const { data: { companyName, email } = {} } = useGetCurrentCompanyApplicationQuery();
  const rightContent = [<TopBarAccountLinks menuTitle={companyName || email} showSwitchCompany={companyToken()} showLogout={isIntuit() || isNonPartner()} />];

  return (
    <div className="Chrome">
      <ResponsiveTopBar branding={branding} rightContent={rightContent} partnerLogo={partnerLogo} partnerName={partnerName} />
      {children}
      <Footer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  partnerLogo: getSiteLogo(state),
  partnerName: getSitePartnerName(state),
});

const withRedux = connect(mapStateToProps);

export default withRouter(withRedux(Chrome));
